<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<style>
    .fab-border {
        border-bottom: 0.5px solid rgb(204, 202, 202);
    }
    .fab-bg {
        background: white!important;
    }
    .fab-shadow-box {
        box-shadow: 0 4px 20px 0 rgba(0,0,0,0)!important;
    }
    .fab-border-close-active {
        border: 2px solid red;
        padding:2px;
        color:red;
        font-weight:bold;
    }
    .fab-border-close-desactive {
        color:black;
        font-weight:bold;
    }
    .fab-border-audio-active {
        border: 2px solid green;
        padding:2px;
        color:green;
        font-weight:bold;
    }
    .fab-border-audio-desactive {
        color:black;
        font-weight:bold;
    }
    .fab-border-video-active {
        border: 2px solid red;
        padding:2px;
        color:red;
        font-weight:bold;
    }
    .fab-border-video-desactive {
        color:black;
        font-weight:bold;
    }
    .fab-border-text-active {
        border: 2px solid blue;
        padding:2px;
        color:blue;
        font-weight:bold;
    }
    .fab-border-text-desactive {
        color:black;
        font-weight:bold;
    }
    .fab-border-folder-active {
        border: 2px solid #f6c682;
        padding:2px;
        color:#f6c682;
        font-weight:bold;
    }
    .fab-border-folder-desactive {
        color:black;
        font-weight:bold;
    }
</style>
<template>
    <div class="relative" style="background-color: #fff!important;">

        <div class="vx-navbar-wrapper fab-border fab-bg" >
            <vs-navbar class="vx-navbar navbar-custom fab-shadow-box" :color="navbarColor" :class="classObj">
                <!-- SM - OPEN SIDEBAR BUTTON -->
                <feather-icon
                    class="sm:inline-flex xl:hidden cursor-pointer mr-1"
                    icon="MenuIcon"
                    @click.stop="showSidebar"
                ></feather-icon>

                <a-input
                    placeholder="Faça sua pesquisa..."
                    style="width: 45%;"

                    size="large"
                    v-model="term_search"

                    >
                </a-input>
                <a-icon
                    :class="`mr-3 ml-3 ${(audio || filters.audio) ?  'fab-border-audio-active' :  'fab-border-audio-desactive'}`"
                    style="fontSize:30px;"
                    type="sound"
                    :theme="`${(audio || filters.audio) ? 'filled' :  'outlined'}`"
                    @click="toggleAudio"
                />
                <a-icon
                    :class="`mr-3 ml-3 ${(video ||  filters.video)  ?  'fab-border-video-active' :  'fab-border-video-desactive'}`"
                    style="fontSize:30px;"
                    type="play-circle"
                    :theme="`${(video ||  filters.video) ? 'filled' :  'outlined'}`"
                    @click="toggleVideo"
                />
                <a-icon
                    :class="`mr-3 ml-3 ${(text || filters.document) ?  'fab-border-close-active' :  'fab-border-close-desactive'}`"
                    style="fontSize:30px;"
                    type="close"
                    @click="toggleText"
                />
                <a-icon
                    :class="`mr-3 ml-3 ${(image || filters.image) ?  'fab-border-text-active' :  'fab-border-text-desactive'}`"
                    style="fontSize:30px;"
                    type="file-image"
                    :theme="`${(image || filters.image) ? 'filled' :  'outlined'}`"
                    @click="toggleImage"
                />
                <a-icon
                    :class="`mr-3 ml-3 ${(folder || filters.folder) ?  'fab-border-folder-active' :  'fab-border-folder-desactive'}`"
                    style="fontSize:30px;"
                    type="folder"
                    :theme="`${(folder || filters.folder) ? 'filled' :  'outlined'}`"
                    @click="toggleFolder"
                />
                <a-button @click="onSearch" type="primary" size="large" class="ml-3">
                    Pesquisar
                    <a-icon color="gray" type="search"/>
                </a-button>


                <template v-if="breakpoint != 'md'">
                    <!-- STARRED PAGES - FIRST 10 -->
                    <ul class="vx-navbar__starred-pages">
                        <draggable
                            v-model="starredPagesLimited"
                            :group="{name: 'pinList'}"
                            class="flex cursor-move"
                        >
                            <li
                                class="starred-page"
                                v-for="page in starredPagesLimited"
                                :key="page.url"
                            >
                                <vx-tooltip :text="page.label" position="bottom" delay=".3s">
                                    <feather-icon
                                        svgClasses="h-6 w-6"
                                        class="p-2 cursor-pointer"
                                        :icon="page.labelIcon"
                                        @click="$router.push(page.url)"
                                    ></feather-icon>
                                </vx-tooltip>
                            </li>
                        </draggable>
                    </ul>

                    <!-- STARRED PAGES MORE -->
                    <div
                        class="vx-navbar__starred-pages--more-dropdown"
                        v-if="starredPagesMore.length"
                    >
                        <vs-dropdown vs-custom-content vs-trigger-click>
                            <feather-icon
                                icon="ChevronDownIcon"
                                svgClasses="h-4 w-4"
                                class="cursor-pointer p-2"
                            ></feather-icon>
                            <vs-dropdown-menu>
                                <ul class="vx-navbar__starred-pages-more--list">
                                    <draggable
                                        v-model="starredPagesMore"
                                        :group="{name: 'pinList'}"
                                        class="cursor-move"
                                    >
                                        <li
                                            class="starred-page--more flex items-center cursor-pointer"
                                            v-for="page in starredPagesMore"
                                            :key="page.url"
                                            @click="$router.push(page.url)"
                                        >
                                            <feather-icon
                                                svgClasses="h-5 w-5"
                                                class="ml-2 mr-1"
                                                :icon="page.labelIcon"
                                            ></feather-icon>
                                            <span class="px-2 pt-2 pb-1">{{ page.label }}</span>
                                        </li>
                                    </draggable>
                                </ul>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </template>

                <vs-spacer></vs-spacer>

                <!-- USER META -->
                <div class="the-navbar__user-meta flex items-center">
                    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                        <vs-avatar />
                        <vs-dropdown-menu class="vx-navbar-dropdown">
                            <ul style="min-width: 9rem">
                                <li
                                    class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                    v-if="isAdmin"
                                    @click="runSync"
                                >
                                    <span class="ml-2">Sincronizar Aristóteles</span>
                                </li>
                                <li
                                    class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                    @click="logoutSystem()"
                                >
                                    <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"></feather-icon>
                                    <span class="ml-2">Logout</span>
                                </li>
                            </ul>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </vs-navbar>
        </div>
    </div>
</template>

<script>
import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import draggable from "vuedraggable";
import { mapActions, mapState } from "vuex";
import isEmpty from "lodash/isEmpty";
import { call, get, sync } from "vuex-pathify";

export default {
    name: "the-navbar",
    props: {
        navbarColor: {
            type: String,
            default: "#fff"
        }
    },
    data() {
        return {
            navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
            searchQuery: "",
            showFullSearch: false,
            settings: {
                // perfectscrollbar settings
                maxScrollbarLength: 60,
                wheelSpeed: 0.6
            },
            autoFocusSearch: false,
            showBookmarkPagesDropdown: false,
            showSearch: true,
            term_search: '',
            audio: false,
            image: false,
            video: false,
            text: false,
            folder: false,
        };
    },
    watch: {
        $route() {
            if (this.showBookmarkPagesDropdown)
                this.showBookmarkPagesDropdown = false;
        }
    },
    computed: {
        ...sync([
            "search/currentPage",
            "search/pageCount",
            "search/results",
            "search/filters",
            "search/lastSearch",
        ]),
        ...get(["search/isSyncRunning", "user/model.groupAlias"]),
        ...mapState("user", ["model"]),
        isAdmin() {
            return this.groupAlias === "administrator";
        },
        // HELPER
        sidebarWidth() {
            return this.$store.state.sidebarWidth;
        },
        term: sync("search/currentTerm"),
        breakpoint() {
            return this.$store.state.breakpoint;
        },

        // NAVBAR STYLE
        classObj() {
            if (this.sidebarWidth == "default") return "navbar-default";
            else if (this.sidebarWidth == "reduced") return "navbar-reduced";
            else if (this.sidebarWidth) return "navbar-full";
        },

        // BOOKMARK & SEARCH
        data() {
            return this.$store.state.navbarSearchAndPinList;
        },
        starredPages() {
            return this.$store.state.starredPages;
        },
        starredPagesLimited: {
            get() {
                return this.starredPages.slice(0, 10);
            },
            set(list) {
                this.$store.dispatch("arrangeStarredPagesLimited", list);
            }
        },
        starredPagesMore: {
            get() {
                return this.starredPages.slice(10);
            },
            set(list) {
                this.$store.dispatch("arrangeStarredPagesMore", list);
            }
        },

        // PROFILE
        user_displayName() {
            if (this.model.name) {
                return this.model.name;
            }
            return null;
        }
    },
    methods: {
         ...call({
            search: "search/search",
            reset: "search/reset",
            searchFolder: "search/searchFolder",
            searchByType: "search/searchByType",
            currentPage: "search/currentPage"
        }),
        runSync: call("search/runSync"),
        ...mapActions("auth", ["logout"]),
        showSidebar() {
            this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
        },
        toggleAudio() {
            this.audio = !this.audio;
            this.filters.audio = this.audio;

            if (this.audio) {
                this.folder = false;
                this.video = false;
                this.text = false;
                this.image = false;
                this.filters.video = false;
                this.filters.document = false;
                this.filters.image = false;
            }
        },
        toggleVideo() {
            this.video = !this.video;
            this.filters.video = this.video;

            if (this.video) {
                this.folder = false;
                this.audio = false;
                this.text = false;
                this.image = false;
                this.filters.audio = false;
                this.filters.document = false;
                this.filters.image = false;
            }
        },
        toggleText() {
            this.text = !this.text;
            this.filters.document = this.text;

            if (this.text) {
                this.folder = false;
                this.audio = false;
                this.video = false;

                this.image = false;
                this.filters.audio = false;
                this.filters.video = false;
                this.filters.image = false;
            }
        },
        toggleImage() {
            this.image = !this.image;
            this.filters.image = this.image;

            if (this.image) {
                this.folder = false;
                this.audio = false;
                this.video = false;
                this.text = false;
                this.filters.audio = false;
                this.filters.video = false;
                this.filters.document = false;
            }
        },
        toggleFolder() {
            this.folder = !this.folder;
            if (this.folder) {
                this.audio = false;
                this.video = false;
                this.text = false;
                this.image = false;
                this.filters.audio = false;
                this.filters.video = false;
                this.filters.document = false;
                this.filters.image = false;
            }
        },
        toggleSearchBar () {
            if (this.$route.path.startsWith('/documents')) {
                return false;
            }
            if (this.$route.path.startsWith('/levels')) {
                return false;
            }
            if (this.$route.path.startsWith('/itens')) {
                return false;
            }
            return true;
        },
        onSearch(event) {
            this.term = this.term_search;
            this.createSearchQuery(true);
        },
        selected(item) {
            this.$router.push(item.url);
            this.showFullSearch = false;
        },
        actionClicked(item) {
            // e.stopPropogation();
            this.$store.dispatch("updateStarredPage", {
                index: item.index,
                val: !item.highlightAction
            });
        },
        async createSearchQuery(resetPagination = false) {

            if (resetPagination) {
                this.currentPage = 1;
            }

            if (isEmpty(this.term)) {
                return;
            }

            this.$vs.loading();
            if (this.folder) {
                await this.searchFolder({term: this.term,  page: this.currentPage });
                this.$vs.loading.close();
                this.isSearchInProgress = false;
            } else {
                await this.searchByType({term: this.term, types: this.filters, page: this.currentPage});
                this.$vs.loading.close();
                this.isSearchInProgress = false;
            }

            this.$router.push({
                path: "/results",
            });
        },
        showNavbarSearch() {
            this.showFullSearch = true;
        },
        showSearchbar() {
            this.showFullSearch = true;
        },
        elapsedTime(startTime) {
            let x = new Date(startTime);
            let now = new Date();
            var timeDiff = now - x;
            timeDiff /= 1000;

            var seconds = Math.round(timeDiff);
            timeDiff = Math.floor(timeDiff / 60);

            var minutes = Math.round(timeDiff % 60);
            timeDiff = Math.floor(timeDiff / 60);

            var hours = Math.round(timeDiff % 24);
            timeDiff = Math.floor(timeDiff / 24);

            var days = Math.round(timeDiff % 365);
            timeDiff = Math.floor(timeDiff / 365);

            var years = timeDiff;

            if (years > 0) {
                return years + (years > 1 ? " Years " : " Year ") + "ago";
            } else if (days > 0) {
                return days + (days > 1 ? " Days " : " Day ") + "ago";
            } else if (hours > 0) {
                return hours + (hours > 1 ? " Hrs " : " Hour ") + "ago";
            } else if (minutes > 0) {
                return minutes + (minutes > 1 ? " Mins " : " Min ") + "ago";
            } else if (seconds > 0) {
                return seconds + (seconds > 1 ? ` sec ago` : "just now");
            }

            return "Just Now";
        },
        outside: function() {
            this.showBookmarkPagesDropdown = false;
        },
        logoutSystem() {
            this.logout();
            this.$router.push({ name: "page-login" });
        }
    },
    directives: {
        "click-outside": {
            bind: function(el, binding) {
                const bubble = binding.modifiers.bubble;
                const handler = e => {
                    if (bubble || (!el.contains(e.target) && el !== e.target)) {
                        binding.value(e);
                    }
                };
                el.__vueClickOutside__ = handler;
                document.addEventListener("click", handler);
            },

            unbind: function(el) {
                document.removeEventListener("click", el.__vueClickOutside__);
                el.__vueClickOutside__ = null;
            }
        }
    },
    components: {
        VxAutoSuggest,
        VuePerfectScrollbar,
        draggable
    }
};
</script>
